import React, { Component, Fragment } from "react";
import { LanguageConsumer, Translate } from "../../contexts/LanguageContext";
import { Card, Loading, BreadCrumb } from '../../components';
import { UserAccounts } from '../../components/UserAccounts';
import DatePicker from "react-datepicker";

export class Settings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            startDate: "",
            endDate: ""
        }
    }
    changeAccount(userAccount) {


    }
    onDateChange(date, stateKey) {
        this.setState({
            [stateKey]: date
        });

        localStorage.setItem(stateKey, date);
    }
    render() {


        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" />
                        <BreadCrumb Title="Settings" Name="Settings" />
                        <Card Title="Settings" Description="Application Settings">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="form-group ml-4 mb-5">
                                        <label>{Translate("Active Account")}</label>
                                        <UserAccounts List className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group ml-4 mb-5">
                                        <label>{Translate("Default Date Range")}</label>
                                        <div>
                                            <div className="row">
                                                <div className="col-md-4">
                                                    <DatePicker
                                                        dateFormat="dd.MM.yyyy"
                                                        className="form-control"
                                                        selected={this.state.startDate}
                                                        onChange={(date) => this.onDateChange(date, "startDate")}
                                                    />
                                                </div>

                                                <div className="col-md-4">
                                                    <DatePicker
                                                        dateFormat="dd.MM.yyyy"
                                                        className="form-control"
                                                        selected={this.state.endDate}
                                                        onChange={(date) => this.onDateChange(date, "endDate")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group ml-4 mb-5">
                                        <label>{Translate("Side Bar")}</label>
                                        <div>
                                            <input type="checkbox" id="switch9" switch="dark" />
                                            <label htmlFor="switch9" data-on-label="Yes" data-off-label="No" className="mt-2 mb-1"></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }

}